import { useQuery } from "@tanstack/react-query";
import { useToken } from "@context/contexts";
import { useApi } from "./useApi";

// Off by default until VITE_CHATWOOT_IDENTITY_ENABLED=true, once
// GET /api/chatwoot/identity is live and the Chatwoot inbox enforces
// identity validation. See chess-backend-new src/api/chatwoot.ts.
const IDENTITY_ENABLED = import.meta.env.VITE_CHATWOOT_IDENTITY_ENABLED === "true";

// Response contract, per chess-backend-new's actual implementation:
// { ok: true, data: { identifier, identifier_hash } } - same {ok, data}
// envelope every other endpoint in this app uses (see UserContext.jsx's
// other queries). The HMAC is computed server-side only; the frontend just
// relays identifier/identifier_hash to window.$chatwoot.setUser.
export const useChatwootIdentity = () => {
    const { token } = useToken();
    const api = useApi();

    return useQuery({
        queryKey: ["chatwoot-identity", token],
        queryFn: async () => {
            const response = await api.get("chatwoot/identity");
            return response.data;
        },
        enabled: IDENTITY_ENABLED && Boolean(token),
        retry: false,
        staleTime: 30 * 60 * 1000,
    });
};
